interface LogoMarkProps {
  size?: number
  className?: string
  color?: string
}

// MPR crosshair — stylized DICOM viewer crosshair with ring.
export function MPRCrosshair({ size = 20, className = '', color = 'white' }: LogoMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" className={className}>
      {/* Outer reference ring */}
      <circle cx="10" cy="10" r="7.5" stroke={color} strokeWidth="1" opacity="0.35" />
      {/* Primary axes — thicker */}
      <line x1="1.5" y1="10"  x2="18.5" y2="10"  stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <line x1="10"  y1="1.5" x2="10"   y2="18.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      {/* Diagonal axes — thinner for hierarchy */}
      <line x1="3.5" y1="16.5" x2="16.5" y2="3.5" stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.55" />
      <line x1="3.5" y1="3.5"  x2="16.5" y2="16.5" stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.55" />
      {/* Center dot */}
      <circle cx="10" cy="10" r="1.6" fill={color} />
    </svg>
  )
}

export default MPRCrosshair
